import { Pipe, PipeTransform } from '@angular/core';
export interface SelectItem {
    value: any;
    label: string;
}
@Pipe({ name: 'selectItem' })
export class SelectItemPipe implements PipeTransform {
    transform(
        items: any[],
        valueProperty: string,
        labelProperties: string | string[],
        preText: string = ''
    ): SelectItem[] {
        if (!Array.isArray(items) || items.length === 0) {
            return [];
        }
        return items.map(item => ({
            value: item,
            label: this.formatLabel(item, labelProperties, preText)
        }));
    }
    private formatLabel(item: any, labelProperties: string | string[], preText: string): string {
        if (Array.isArray(labelProperties)) {
            const labels = labelProperties.map(prop => item[prop]).filter(Boolean);
            return `${preText}${labels.join(' - ')}`.trim();
        }
        return `${preText}${item[labelProperties]}`.trim();
    }
}



// WEBPACK FOOTER //
// ./src/app/util/pipe-select-item.ts